'use strict';

import {hasClass, addClass, removeClass} from './helpers';

const header = document.querySelector('header');
const windowH = window.innerHeight;
let offWatch = false;
// let scrollCnt = 0;
export const watchScroll = (newVal, oldVal) => {
  // const contentHeight = document.querySelector('#scroller').getBoundingClientRect().height;
  // const delta = Math.round((newVal - oldVal) * 100000) / 100000;
  // const fNewVal = Math.floor((newVal) * 100000) / 100000;
  // const fOldVal = Math.floor((oldVal) * 100000) / 100000;
  // console.log(scrollCnt);
  // console.log({newVal, oldVal});
  // console.log('custom onScroll', {scrTop, delta, contentHeight});
  // if (newVal !== oldVal && offWatch) {
  //   offWatch = false;
  // }
  // if (offWatch) return;

  seeHome(newVal);
  seeHeader(newVal, oldVal);
  seeDataAnim(newVal);
  seePrlxImage(newVal, oldVal);
  scrollRotate(newVal);

  // animBlocks();

  lazyImage(newVal);

  if (!document.body.classList.contains('is-touch-device')) {
    animFooter(newVal);
  }

  // if (newVal === oldVal) {
  //   offWatch = true;
  // }
  // scrollCnt++;
};

const lazyImage = (scrTop) => {
  const _images = document.querySelectorAll('[data-lazy-picture]') || [];
  _images.forEach(_block => {
    const _el = _block.closest('[data-lazy-parent]') || _block;
    const top = _el.getBoundingClientRect().top || 0;
    if (top < window.innerHeight * 2) {
      _block.outerHTML =`<div class="sh-lazy">` +
                          `${_block.innerHTML}` +
                          `<div class="sh-lazy__load">${_block.getAttribute('data-lazy-picture')}</div>` +
                        `</div>`;
    }
  });
};

const setTransformStyle = (_el, transform) => {
  if (_el) {
    _el.style["transform"] = transform;
    _el.style["webkitTransform"] = transform;
    _el.style["mozTransform"] = transform;
    _el.style["msTransform"] = transform;
  }
};

const seeHome = (scrTop) => {
  const _blog = document.querySelector('.home_blog');
  const _references = document.querySelector('.home_references');
  const _join = document.querySelector('.join_block');
  if (_blog) {
    const hbRect = _blog.getBoundingClientRect();
    const _bg = document.querySelector('.backgrounds .bg_one--blog') || '';
    // console.log(hbRect.top < windowH * 0.5,hbRect.top, windowH , hbRect.top + hbRect.height);
    if (hbRect.top < windowH * 0.5 && hbRect.top + hbRect.height * 0.35 > 0) {
      if (!hasClass(_bg, 'in-view')) {
        addClass(_bg, 'in-view');
      }
    } else if (hasClass(_bg, 'in-view')) {
      removeClass(_bg, 'in-view');
    }
  }
  if (_join) {
    const joinRect = _join.getBoundingClientRect();
    const joinTitle = _join.querySelector('.join_block__title');
    const joinText = _join.querySelector('.join_block__info__wrap');
    const _bg = document.querySelector('.backgrounds .bg_one--join') || '';
    if (joinRect.top < windowH * 0.5 && joinRect.top + joinRect.height * 0.35 > 0) {
      if (!hasClass(_bg, 'in-view')) {
        addClass(_bg, 'in-view');
      }
    } else if (hasClass(_bg, 'in-view')) {
      removeClass(_bg, 'in-view');
    }

    if (joinRect.top < windowH && joinRect.top + joinRect.height > 0) {
      let t = Math.round((joinRect.top > 0 ? joinRect.top * 0.8 : 0)) / 100 * -1;

      setTransformStyle(joinTitle, `translate(${30 * t}px, ${10 * t}px) translateZ(0) rotate(${t / 1.5}deg)`);
      setTransformStyle(joinText, `translateY(${-10 * t}px) translateZ(0)`);
    }


  }
  /*TODO create animation for new design*/
  if (_references) {
    const rfRect = _references.getBoundingClientRect();
    // const _bg = document.querySelector('.backgrounds .bg_one--refs') || '';
    if (rfRect.top < windowH * 0.7 && rfRect.top + rfRect.height * 0.6 > 0) {
      /*if (!hasClass(_bg, 'in-view')) {
        addClass(_bg, 'in-view');
      }*/
      const t = Math.round(rfRect.height / 1.5 - windowH * 0.7 - rfRect.top) / 100;
      // console.log( t*5, rfRect.top + rfRect.height*0.7);
      const _left = document.querySelector('.home_references__slide__half.left');
      const _right = document.querySelector('.home_references__slide__half.right');
      setTransformStyle(_left, `translateY(${-6 * t}px) translateZ(0)`);
      setTransformStyle(_right, `translateY(${4.5 * t}px) translateZ(0)`);

    }/* else if (hasClass(_bg, 'in-view')) {
      removeClass(_bg, 'in-view');
    }*/
  }
};

const headerH = header.getBoundingClientRect().height;
const areaH = windowH + headerH;
const zoneH = areaH * (window.innerWidth > window.innerHeight ? 0.3 : 0.2);
const transH = areaH * (window.innerWidth > window.innerHeight ? 0.08 : 0.05);
const topStart = 0;
const topFinish = topStart + zoneH;
const botStart = areaH - zoneH;
const botFinish = areaH;

const getPercent = (rect) => {
  let direction = 0;
  let value = 0;
  if (!rect) return {value, direction};

  const topPos = rect.top + rect.height;
  const botPos = rect.top;

  if (topPos >= topStart && topPos <= topFinish) {
    direction = 1;
    value = Math.round(topPos - topStart) / zoneH; // from 0% to 100%
  } else if (topPos > topFinish && botPos < botStart) {
    value = 1; // showing
  } else if (botPos >= botStart && botPos <= botFinish) {
    direction = -1;
    value = 1 - Math.round(botPos - botStart) / zoneH; // from 100% to 0%
  }

  return {value, direction};
};
const animBlocks = (newY, oldY) => {
  // const toBottom = oldY < newY;
  return;

  const _blocks = document.querySelectorAll('[data-scroll-parent]');
  _blocks.forEach(_block => {
    const _inner = _block.querySelector('[data-scroll-inner]');
    if (!_inner) return;
    const percent = getPercent(_block.getBoundingClientRect());
    // console.log({percent});
    const transY = percent.direction * transH - percent.direction * transH * percent.value;
    _inner.style["opacity"] = percent.value;
    setTransformStyle(_inner, `translateY(${transY}px) translateZ(0)`);
  });
};

const animFooter = (newVal) => {
  const scrollerH = document.getElementById('scroller').clientHeight;
  const windowBotPos = Math.round(newVal + window.innerHeight);
  const footerH = document.querySelector('[data-scroll-footer]').clientHeight;
  const scrollToDocumentBot = scrollerH - windowBotPos
  const floatButtonToTop = document.querySelector('.float-btn--arrow');

  if (scrollToDocumentBot < footerH) {
    const _footerAnimItems = document.querySelectorAll('[data-scroll-footer-item]');

    _footerAnimItems.forEach((_item, index) => {
      const transY = scrollToDocumentBot * ((index + 1) * 0.2);
      setTransformStyle(_item, `translateY(-${transY}px) translateZ(0)`);
    });

    /*float button to top*/
    if (hasClass(document.body, 'is-loaded')) {
      addClass(floatButtonToTop, 'is-hidden');
    }
  } else {
    if (hasClass(document.body, 'is-loaded')) {
      removeClass(floatButtonToTop, 'is-hidden');
    }
  }
};

const seeDataAnim = (scrTop) => {
  const _blocks = document.querySelectorAll('[data-anim]');
  if (!_blocks.length) return;

  _blocks.forEach((_el) => {
    const dataAnim = _el.getAttribute('data-anim');
    const rect = _el.getBoundingClientRect();
    if (rect.top < windowH * 0.8 && rect.top > -rect.height) {
      if (dataAnim === 'false') {
        _el.setAttribute('data-anim', 'true');
      }
    } else if (dataAnim === 'true') {
      _el.setAttribute('data-anim', 'false');
    }
  });
};

const seePrlxImage = (scrTop) => {
  const _blocks = document.querySelectorAll('[data-scroll-parallax]');
  if (!_blocks.length) return;

  _blocks.forEach((_el) => {
    const diff = parseFloat(_el.getAttribute('data-scroll-parallax') || 0);
    const rect = _el.getBoundingClientRect();
    const reverse = _el.getAttribute('data-reverse') ? -1 : 1;
    if (rect.top < windowH && rect.top > -rect.height) {
      const _img = _el.querySelector('img');
      const curr = windowH - rect.top;
      const full = rect.height + windowH;
      const per = Math.round(curr / full * 1000) / 1000 * diff * reverse;
      setTransformStyle(_img, `translateY(${per}%) translateZ(0)`);
    }
  });
};

const scrollRotate = (scrTop) => {
  const val = scrTop / 400 % Math.PI;
  let spinners = document.querySelectorAll('[data-spin-item]');
  spinners.forEach((spinner) => {
    setTransformStyle(spinner, `rotate(${val}rad)`);
  })
}

const seeHeader = (scrTop, oldVal) => {
  const _app = document.querySelector('#app');
  const scrollUp = 'scroll-up';
  const scrollDown = 'scroll-down';
  const notInTop = 'not-in-top';
  const servicesOpenedClass = 'services--opened';

  if (scrTop <= 1) {
    removeClass(_app, scrollUp);
    return;
  }

  if (scrTop > 50) {
    addClass(_app, notInTop);
  } else {
    removeClass(_app, notInTop);
  }

  if (scrTop > oldVal && !hasClass(_app, scrollDown) && hasClass(_app, notInTop)) {
    // down
    removeClass(_app, scrollUp);
    addClass(_app, scrollDown);
  } else if (scrTop < oldVal && hasClass(_app, scrollDown)) {
    // up
    removeClass(_app, scrollDown);
    addClass(_app, scrollUp);
  }

  // close services menu
  if (hasClass(_app, servicesOpenedClass)) {
      removeClass(_app, servicesOpenedClass);
  }


  // const dataPage = _app.getAttribute('data-page');
  // if (dataPage === 'project_single' || dataPage === 'blog_single') {
  //   const rectS = document.querySelector('[data-type="scroll-header"]').getBoundingClientRect();
  //   const rectH = document.querySelector('header').getBoundingClientRect();
  //   if (rectS.top - rectH.height > -rectS.height) {
  //     if (!hasClass(_app, 'header--transparent')) {
  //       addClass(_app, 'header--transparent');
  //     }
  //   } else if (hasClass(_app, 'header--transparent')) {
  //     removeClass(_app, 'header--transparent');
  //   }
  // } else {
  //   removeClass(_app, 'header--transparent');
  // }
};
